module.exports = __webpack_public_path__ + "static/img/Logo Glomed.675967c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo Glomed.png
// module id = 1U8g
// module chunks = 7